const API_HOST = process.env.REACT_APP_API_HOST || 'https://localhost:8000';
export const API_BASE = `${API_HOST}/api/strategies`;
export const AUTH_URL = `${API_HOST}/api/auth/token/`;

export const getToken = () => localStorage.getItem('hf_access');

export const setTokens = (access, refresh) => {
  localStorage.setItem('hf_access', access);
  localStorage.setItem('hf_refresh', refresh);
};

export const clearTokens = () => {
  localStorage.removeItem('hf_access');
  localStorage.removeItem('hf_refresh');
};

export const isAuthenticated = () => !!getToken();

export const authFetch = (url, options = {}) => {
  const { headers = {}, ...rest } = options;
  return fetch(url, {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
      'Authorization': `Bearer ${getToken()}`,
    },
  }).then((res) => {
    if (res.status === 401) {
      clearTokens();
      window.location.reload();
    }
    return res;
  });
};
